import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import PatientBiometricsUpdate from "../../models/idg/patient-biometrics-update";
import Measure from "../../models/patient-chart/biometrics/measure";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class BiometricsService {
  private apiUrl: string;
  private idgDataUrl: string;

  constructor(private http: HttpClient, private config: ConfigurationService) {
    this.apiUrl = config.getConfig().apiUrl;
    this.idgDataUrl = config.resolveIdgUrl();
    if (
      this.config.getConfig().isLocal &&
      this.config.getConfig().localEndpoints.patientChartBiometrics
    ) {
      this.apiUrl =
        this.config.getConfig().localEndpoints.patientChartBiometrics;
    } else {
      this.apiUrl = this.config.getConfig().apiUrl;
    }
  }

  /**
   * Gets the time based data for a patient and a measure
   * @param patientChartId the patient to get the data for
   * @param measure the measure to extract
   */
  public getReadings(
    patientChartId: number,
    measure: string
  ): Observable<Measure> {
    return this.http.get<Measure>(
      `${this.apiUrl}/patient-charts/${patientChartId}/biometrics?measure=${measure}`
    );
  }

  /**
   * Call endpoint to update patient biometrics data
   * @param patientChartId the patient to get the data for
   * @param meetingId the meeting ID
   * @param patientBiometricsUpdate the patient biometrics update
   */
  public updatePatientBiometrics(
    patientChartId: number,
    meetingId: string,
    patientBiometricsUpdate: PatientBiometricsUpdate
  ): Observable<any> {
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.http.put<any>(
      `${this.idgDataUrl}/patient-charts/${patientChartId}/meetings/${meetingId}/biometrics?externalId=True`,
      patientBiometricsUpdate,
      { headers: headers }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/biometrics.service.ts